import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { Button, Container } from "react-bootstrap";

export const selectableCalculators = [
  { i18nPrefix: "elake-arvio-laskuri", pathName: "elakelaskuri" },
  { i18nPrefix: "ove-laskuri", pathName: "osittaisen-vanhuuselakkeen-laskuri" },
  { i18nPrefix: "perhe-elakelaskuri", pathName: "perhe-elakelaskuri" },
  {
    i18nPrefix: "elake-perhevapaan-ajalta-laskuri",
    pathName: "elake-perhevapaan-ajalta-laskuri",
  },
  { i18nPrefix: "yttari", pathName: "yel-tyotulo-suositus-laskuri" },
];
const CalculatorSelector: React.FC = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  return (
    <Container className="calculator-container content-container">
      <h1>{t("selector.calculatorTitle")}</h1>
      <p>
        <Trans
          i18nKey={"selector.ingress"}
          components={{
            Link1: <a href={t(`selector.url1`)}>https://example.com/1</a>,
          }}
        />
      </p>
      {selectableCalculators.map((calculator) => (
        <Button
          className={"w-100 btn-primary mb-3"}
          key={calculator.i18nPrefix}
          onClick={(e) => {
            e.preventDefault();
            globalThis.location.pathname = `/${language}/${calculator.pathName}`;
          }}
        >
          {t(`${calculator.i18nPrefix}.name`)}
        </Button>
      ))}
    </Container>
  );
};

export default CalculatorSelector;
